module.exports = __webpack_public_path__ + "static/img/5.917d7a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/5.png
// module id = roqE
// module chunks = 0